import { render, staticRenderFns } from "./SupplierDetailPage.vue?vue&type=template&id=1736a387&scoped=true&"
import script from "./SupplierDetailPage.vue?vue&type=script&lang=js&"
export * from "./SupplierDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./SupplierDetailPage.vue?vue&type=style&index=0&id=1736a387&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1736a387",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1736a387')) {
      api.createRecord('1736a387', component.options)
    } else {
      api.reload('1736a387', component.options)
    }
    module.hot.accept("./SupplierDetailPage.vue?vue&type=template&id=1736a387&scoped=true&", function () {
      api.rerender('1736a387', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/supplierDetailPages/SupplierDetailPage.vue"
export default component.exports